import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER, ErrorHandler } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { NzConfig, NZ_CONFIG } from "ng-zorro-antd/core/config";
import { GLOBAL_NZCONFIG } from "./constants";
import { SocketIoModule, SocketIoConfig } from "ngx-socket-io";
import { SocketService } from "./services/socket.service";
import { environment } from "../environments/environment";
import { HttpInterceptorService } from "./services/http-interceptor.service";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";
import { AuthModule } from "./pages/auth/auth.module";
import { CurrencyPipe, registerLocaleData } from "@angular/common";
import de from "@angular/common/locales/de";
import en from "@angular/common/locales/en";
import { en_US, NZ_I18N } from "ng-zorro-antd/i18n";
import { DelimiterPipe } from "./pipes/delimiter/delimiter.pipe";

import { NgxChartsModule } from "@swimlane/ngx-charts";
import { SharedModule } from "./pages/shared-component/shared.module";
import { ProfileService } from "./services/profile.service";
import { UsersService } from "./services/users.service";
import { VolumePricePipe } from "./pipes/volumeprice/volume-price.pipe";
import { VolumePriceModule } from "./pipes/volumeprice/volume-price.module";
import { FileSizePipe } from "./pipes/fileSize/file-size.pipe";
import { UserRoleDirective } from "./directives/user-role/user-role.directive";
import { UserRoleModule } from "./directives/user-role/user-role.module";
import { TimezoneDatePipe } from "./pipes/timezone-date/timezone-date.pipe";
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { Router } from "@angular/router";
import { ApiKeyStatusTypesPipe } from "./pipes/api-key-status-types/api-key-status-types.pipe";

const config: SocketIoConfig = {
	url: environment.API_ENDPOINT,
	options: { transports: ["websocket"] },
};

const ngZorroConfig: NzConfig = GLOBAL_NZCONFIG;

registerLocaleData(de);
registerLocaleData(en);

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		SharedModule,
		AppRoutingModule,
		NgxSpinnerModule,
		AuthModule,
		BrowserAnimationsModule,
		HttpClientModule,
		SocketIoModule.forRoot(config),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		NgxChartsModule,
		VolumePriceModule,
		UserRoleModule,
		NzToolTipModule
	],
	exports: [SharedModule, TranslateModule],
	providers: [
		{ provide: NZ_CONFIG, useValue: ngZorroConfig },
		{ provide: NZ_I18N, useValue: en_US },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpInterceptorService,
			multi: true
		},
		SocketService,
		DelimiterPipe,
		VolumePricePipe,
		CurrencyPipe,
		SharedModule,
		ApiKeyStatusTypesPipe,
		ProfileService,
		FileSizePipe,
		UsersService,
		TimezoneDatePipe
	],
	bootstrap: [AppComponent]
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
	return new TranslateHttpLoader(http);
}
